export default process.env.RAX_VERSION;
